import { IAttrValue, IRowData } from "@multiweb/types/contracts";
import { IOrderBy } from "../../Global/Base/DataSources/Interfaces";
import { IAwaitableEvent } from "../UI.BaseControls/AwaitableEvent";
import { FileEditStatus } from "../UI/UI/FileMenu";
import { Column } from "./DataGridSubcontrols/Columns/Column";
import { IDataRowElement } from "./DataGridSubcontrols/Components/IDataRow";
import { IAdditionalGroupingParams } from "./DataSource/GroupingTreeViewDataSource";
import { IDataGrid } from "./IDataGrid";

export interface IDataGridSelectionChangedEvent extends CustomEvent {
    detail: IDataGridSelectionChangedEventData;
}

export interface IDataGridSelectionChangedEventData {
    dataGrid: IDataGrid<IDataRowElement>;
    rowID: string;
    data: any;
}

export interface IGroupingDataGridSelectionChangedEventData extends IDataGridSelectionChangedEventData {
    conditionData: Array<IAdditionalGroupingParams>;
}

export interface IDataGridMultipleSelectionChangedEvent extends CustomEvent {
    detail: IDataGridMultipleSelectionChangedEventData;
}

export interface IDataGridMultipleSelectionChangedEventData {
    dataGrid: IDataGrid<IDataRowElement>;
    rowIDs: string[];
    data: any;
}

export interface IDataGridDataShownEvent extends CustomEvent {
    detail: IDataGridDataShownEventData;
}

export interface IDataGridDataShownEventData {
    data: () => Iterable<IRowData>;
}

export interface IColumnOrderingChangedEvent extends CustomEvent {
    detail: IColumnOrderingChangedEventData;
}

export interface IColumnOrderingChangedEventData {
    order: IOrderBy[];
}

export interface IColumnPositionChangedEvent extends CustomEvent {
    detail: IColumnPositionChangedEventData;
}

export interface IColumnPositionChangedEventData {
    oldColumnsVisibility: boolean[];
    column: Column;
    newPosition: number;
    oldPosition: number;
    dontUpdate?: boolean;
}

export interface IFileUploadStatusChangeEvent extends CustomEvent {
    detail: IFileUploadStatusChangeEventData;
}

export interface IFileUploadStatusChangeEventData {
    status: FileEditStatus;
}

export interface ICellValueChangedPrewAwaitableEvent extends IAwaitableEvent<boolean> {
    detail: ICellValueChangedPrewAwaitableEventData;
}

export interface ICellValueChangedPrewAwaitableEventData {
    attrName: string;
    value: IAttrValue;
}

export interface GlobalCustomEvent<DetailType> extends CustomEvent {
    detail: DetailType;
}
